module.exports = __webpack_public_path__ + "feature-highlight-3-2x-22cf366c886dd4892a21413e144fa0df.webp";